<template>
  <router-view v-slot="{ Component, route }">
    <!-- 自定义不需要缓存的name -->
    <keep-alive :exclude="excludePage">
      <component :is="Component" :key="route.path"></component>
    </keep-alive>
  </router-view>
</template>


<script setup>
import '@PF/styles/app.scss'
import { getKey } from '@GLOBAL/bridge';
import { initPinia } from '@GLOBAL/pinia';
import { constConf } from '@GLOBAL/constConf';
import { toast } from '@UTILS/toast';
import { report } from '@UTILS/report';
import { constant } from '@PF/constant';
import networkCheck from '@HOOKS/networkCheck';
import useDataStore from '@CPF/pinia/data';
import useUserStore from '@ywxk/pinia/user';
import onReadyOrActive from '@HOOKS/onReadyOrActive';
import visibilitychange from '@HOOKS/visibilitychange';

// 全局数据
const { IS_LOCAL } = constConf
const { IS_APP, IS_PC } = constant

// pinia
const dataStore = useDataStore()
const userStore = useUserStore()
const { isReady } = storeToRefs(dataStore)


// 网络监控
const { isOnline } = networkCheck()
watch(isOnline, (bol) => !bol && toast('网络有点卡了，小可爱请稍后再试下哦~'))

// <===================================== 帧率上报 ======================================
const { isShowPage } = visibilitychange()
let timer = null
watch(isShowPage,
  (bol) => {
    if (bol) {
      timer = setInterval(() => {
        report.fps()
      }, 60 * 1e3);
    } else {
      clearInterval(timer)
      timer = null
    }
  },
  { immediate: true }
)
// ====================================== 帧率上报 =====================================>


// <===================================== 上报 ======================================
// 上报数据
const reportTime = () => {
  report.performance({
    readyTime,
    getKeyTime
  })
}
onReadyOrActive(isReady, () => {
  // 等待动态统计数据完成
  setTimeout(reportTime, 3000)
})
// ====================================== 上报 =====================================>

// <===================================== 判断环境 ======================================
let getKeyTime = 0
const getLoginInfo = async () => {
  try {
    getKeyTime = +new Date()
    // 线上平均耗时10-60,安全起见远程提高超时
    await getKey({ isApp: IS_APP, isPc: IS_PC, timeout: IS_LOCAL ? 200 : 1000 })
    getKeyTime = +new Date() - getKeyTime
    initPinia()
    initData()
  } catch (err) {
    getKeyTime = 0
    console.error(err)
  }
}
getLoginInfo()
// ====================================== 判断环境 =====================================>

// <===================================== 初始化 ======================================
// 不缓存页面
const excludePage = ref([])
// 不需要初始化路由
const excludePath = ref([])
let readyTime = 0
const initData = async () => {
  // 需要请求活动的路由,例如一些规则分享是不需要数据
  if (!excludePath.value.includes(location.hash.slice(1))) {
    readyTime = +new Date()
    // 需要预先完成请求放在这里执行,方便统计前置耗时
    await userStore.getPlayer();
    readyTime = +new Date() - readyTime
  }
  dataStore.setIsReady(true)
}
// ====================================== 初始化 =====================================>
</script>
